import React, { ReactNode } from 'react';
import { StoreEnhancer } from 'redux';

import DevToolsButton, { DevToolsProps } from './source/components/DevToolsButton';
import ReduxDevTools from './source/components/ReduxDevTools';
import { isInDevToolsEnvironment } from './source/environments/isInDevToolsEnvironment';
import { isReduxDevToolsEnabled } from './source/utilities/cookies';

let reduxDevToolsSetup = false;

export function recordReduxDevToolsSetup() {
  reduxDevToolsSetup = true;
}

export function isReduxDevToolsSetup() {
  return reduxDevToolsSetup;
}

const devTools = {
  renderDevToolsButton(props: DevToolsProps = {}): ReactNode {
    return isInDevToolsEnvironment() ? <DevToolsButton {...props} /> : null;
  },

  renderReduxDevTools(): ReactNode {
    return null;
  },

  // Any file that accesses redux-dev-tools related packages should be called in this function, so that they can be
  //   tree-shaken by the bundler during production builds.
  loadForRedux(): StoreEnhancer | null {
    if (!process.env.PRODUCTION) {
      recordReduxDevToolsSetup();

      if (isInDevToolsEnvironment() && isReduxDevToolsEnabled()) {
        this.renderReduxDevTools = () => <ReduxDevTools />;
        return ReduxDevTools.instrument();
      }
    }

    return null;
  },
};

export default devTools;
